import React from 'react';
import { Monitor } from 'lucide-react';

// El softphone de escritorio (Electron) fue retirado: TODAS las llamadas se hacen
// desde el Marcador del panel web (WebRTC). Además el registro SIP externo está
// bloqueado por firewall (solo el panel/WSS y la troncal pueden hablar SIP), así
// que no se ofrece descarga ni aprovisionamiento pbxphone:// (que además exponía
// la contraseña SIP en el enlace).
export default function AppsPage() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-white">Apps</h1>
        <p className="text-gray-400 mt-1 text-sm">Aplicaciones para tu sistema PBX Virtual</p>
      </div>

      <div className="bg-gray-900 border border-gray-800 rounded-xl p-6">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
            <Monitor size={24} className="text-white" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-white">Telefonía integrada en el panel</h2>
            <p className="text-gray-400 text-sm mt-1">
              Todas las llamadas se realizan desde el <b className="text-gray-200">Marcador</b> del panel
              web (softphone WebRTC integrado). No hace falta instalar ninguna aplicación externa.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
